export class Audio {
    constructor (quill, options = {}) {
        this.quill = quill;
        this.id = options.id;
        this.url = options.url;
        this.rootElement = document.querySelector(`#${options.id}`);

        this.handleClick = this.handleClick.bind(this);
        this.handleButton();

        let toolbar = quill.getModule('toolbar');
        toolbar.addHandler('audio', this.handleClick);
    }

    /**
     * Build the dropdown element.
     */
    handleButton () {
        const label = this.rootElement.querySelector('.ql-audio');
        label.id = 'audio-button-' + this.id;
        label.innerHTML = '<i class="fa fa-file-audio-o"></i>';
    }

    /**
     * Handler for click event
     * @param {Event} evt
     */
    handleClick (evt) {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', '.mp3');
        input.click();

        // Listen upload local image and save to server
        input.onchange = () => {
            const file = input.files[0];
            this.uploadFile(file);
        };
    }

    /**
     * Step2. save to server
     *
     * @param {File} file
     */
    uploadFile (file) {
        let formData = new FormData();
        formData.append('file', file);

        axios({
            url: this.url,
              method: 'POST',
            data: formData
        }).then(response => {
            let url = response.data.path;
            let position = this.quill.getSelection(true).index;

            this.quill.editor.insertEmbed(position, 'audio', { url });
            this.quill.setContents(this.quill.getContents());
            this.quill.setSelection(position);
        }).catch(error => {
            console.log(error);
        });
    }
}
